import { Util } from '@/modules/util'
import { Request } from '@/classes/Request'

export interface AccountSettings {
  firstName: string
  lastName: string
  email: string
  password: string
  requireSecurityQuestion: boolean
  securityQuestion: string
  securityQuestionId: number
  securityQuestionCustom: string
  securityAnswer: string
  phoneNumber: string
  phoneType: number
  address: Address
  useBlastEmail: boolean
  useBlastVoice: boolean
  useBlastSms: boolean
}

export interface Address {
  address1: string
  address2: string
  cityId: number
  cityCustom: string
  cityName: string
  stateId: number
  stateCode: string
  stateName: string
  zip: string
  countryId: number
  countryName: string
}

// GET /account_settings
export const accountSettings = async () => {
  const response = await new Request().get('/ajax/account_settings')
  return Util.Obj.keysToCamel(response.data.account_settings_info) as AccountSettings
}
